import Axios from './Axios';

const providers = {
    Axios: new Axios(),
};

export default providers.Axios;
